// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"acc960ab","173":"75403144","454":"5e8c3e1d","480":"d54b0686","589":"c37737a6","626":"3066521c","791":"d378511c","898":"f35f007c","995":"f6165e27"}[chunkId] + ".chunk.js";
};